import React from 'react'

export default function ITEAdministrationManual() {
    return <div>ITE Administration Manual</div>
}
